export function isDuringPeriod(from: Date, to: Date) {
    const current = new Date();
    const isStarted = !from || from < current;
    const isEnded = to && to < current;
    return isStarted && !isEnded;
}
